import AppLogo from '@/assets/img/p-logo.svg';
import { LocationDropDown } from '../location/LocationDropDown';
import { LanguageDropDown } from '../../features/Language/LanguageDropDown';
import { ReactComponent as Topheader1 } from '@/assets/img/Topheader-1.svg';
import { ReactComponent as Topheader2 } from '@/assets/img/Topheader-2.svg';
// import { ReactComponent as Topheader3 } from '@/assets/img/Topheader-3.svg';
import Menuicon from '@/assets/img/breadcrumb.svg';
import './TopHeader.scss';
import { SUPER_ADMIN_ROLE } from '@/config';
import { useSocket } from '@/lib/websocket';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import storage from '@/utils/storage';
import { NotificationTab } from '../NotificationTab/NotificationTab';
import { useEffect, useMemo, useState } from 'react';
import { useGetUreadNotifications } from '@/features/auth/api/notifications';
import { useAuth } from '@/lib/auth';
import { showNotification } from '@/utils/notificationUtils';
type MobileSidebarProps = {
  onNavigate: () => void;
  canShowLocationDropDown: boolean;
  setSidebarOpen: (value: boolean) => void;
};
export const TopHeader = ({
  onNavigate,
  canShowLocationDropDown,
  setSidebarOpen,
}: MobileSidebarProps) => {
  const { logout, user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const useGetUnreadNotificationCount = useGetUreadNotifications();
  const { lastJsonMessage }: any = useSocket(storage.getToken());

  useEffect(() => {
    getUnreadCount();
  }, []);

  const getUnreadCount = async () => {
    const res = await useGetUnreadNotificationCount.mutateAsync({
      page: 1,
      perPage: 10,
    });
    if (res && res.unread) {
      setUnreadCount(res.unread);
    }
  };

  useEffect(() => {
    const onNotification = (newMsg: any) => {
      if (!newMsg) return;

      if (newMsg.businessId === user?.businessId) {
        if (newMsg?.bookingDate && user?.isAdmin) {
          setUnreadCount(Number(unreadCount) + 1);
          showNotification({
            type: 'info',
            title: `You have a new appointment booking`,
          });
        } else if (!newMsg?.bookingDate && newMsg?.appointmentId === null && user?.isAdmin) {
          setUnreadCount(Number(unreadCount) + 1);
          showNotification({
            type: 'info',
            title: `You have a new message from ${newMsg?.fromUser?.name}`,
          });
        } else if (newMsg?.bookingDate && !user?.isAdmin) {
          setUnreadCount(Number(unreadCount) + 1);
          showNotification({
            type: 'info',
            title: `You have a new appointment booking`,
          });
        }
      }
    };

    if (lastJsonMessage && lastJsonMessage.type === 'notification') {
      onNotification(lastJsonMessage.message);
    }
  }, [lastJsonMessage]);

  const markRead = () => {
    setUnreadCount(0);
    getUnreadCount();
  };
  const handleMenuTransition = () => {
    const sidebar = document.getElementById('sidebar');
    const mainContent = document.getElementById('main-content');
    if (sidebar && mainContent) {
      if (sidebar.style.width == '0px') {
        sidebar.style.width = '17.625rem';
        mainContent.style.marginLeft = '17.625rem';
      } else {
        sidebar.style.width = '0';
        mainContent.style.marginLeft = '0';
      }
    }
  };
  return (
    <header>
      <div className="left-side cursor-pointer">
        <button className="breadcrumb" onClick={() => setSidebarOpen(true)}>
          <img src={Menuicon} className="menu-icon" />
        </button>
        <button className="breadcrumb-medium" onClick={() => handleMenuTransition()}>
          <img src={Menuicon} className="menu-icon" />
        </button>
        <img
          onClick={() => {
            onNavigate();
          }}
          src={AppLogo}
          className="logo-icon"
        />
      </div>
      <div className="right-side">
        {/* {<LanguageDropDown></LanguageDropDown>} */}
        <div className="short-icon">
          <div className="icon-bg active">
            {/* <Topheader1 /> */}
            {<NotificationTab onMarkRead={markRead} unreadCount={unreadCount} />}
          </div>
          {unreadCount > 0 && (
            <span className="not-read-count">
              <span>{unreadCount}</span>
            </span>
          )}
        </div>
        {<LocationDropDown></LocationDropDown>}
      </div>
    </header>
  );
};
